import React, { Fragment } from 'react'
import { Grid, Icon } from 'semantic-ui-react'
import { MainContext } from './State'

const Score = () => {
  return (
    <MainContext.Consumer>
      {({ onChange, scores, gameData: { id, team1, team2 } }) => (
        <Fragment>
          <Grid.Row color="blue">
            <h2>Score</h2>
          </Grid.Row>
          <Grid.Row columns="equal" divided color="blue">
            <Grid.Column>
              <Grid.Row>
                <h4>{team1.abbreviated}</h4>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <h2>{scores[0]}</h2>
                  </div>
                  <div>
                    <Icon
                      size="large"
                      bordered
                      name="plus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'scores',
                            value: [scores[0] + 1, scores[1]]
                          }
                        })
                      }
                    />
                    <br />
                    <Icon
                      size="large"
                      bordered
                      name="minus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'scores',
                            value: [scores[0] - 1, scores[1]]
                          }
                        })
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <h4>{team2.abbreviated}</h4>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <h2>{scores[1]}</h2>
                  </div>
                  <div>
                    <Icon
                      size="large"
                      bordered
                      name="plus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'scores',
                            value: [scores[0], scores[1] + 1]
                          }
                        })
                      }
                    />
                    <br />
                    <Icon
                      size="large"
                      bordered
                      name="minus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'scores',
                            value: [scores[0], scores[1] - 1]
                          }
                        })
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Fragment>
      )}
    </MainContext.Consumer>
  )
}

export default Score



// WEBPACK FOOTER //
// ./src/components/Controller/Score.jsx